<template>
  <div>
    <el-form-item label="选位置题干" :error="errors.xktc">
      <el-input v-model="formData.xktc" @blur="handleFormat('formData.xktc')" placeholder="留空则不出这道题"></el-input>
    </el-form-item>
    <el-form-item label="4选1题干" :error="errors.xctk_4x1">
      <el-input v-model="formData.xctk_4x1" @blur="handleFormat('formData.xctk_4x1')" placeholder="留空则不出这道题"></el-input>
    </el-form-item>
    <el-form-item label="4选1干扰项">
      <el-input v-model="formData.xctk_4x1_items" @blur="handleFormat('formData.xctk_4x1_items', 'items')"
                placeholder="留空则不出这道题"></el-input>
    </el-form-item>
    <el-form-item label="4选2题干" :error="errors.xctk_4x2">
      <el-input v-model="formData.xctk_4x2" @blur="handleFormat('formData.xctk_4x2')" placeholder="留空则不出这道题"></el-input>
    </el-form-item>
    <el-form-item label="4选2干扰项">
      <el-input v-model="formData.xctk_4x2_items" @blur="handleFormat('formData.xctk_4x2_items', 'items')"
                placeholder="留空则不出这道题"></el-input>
    </el-form-item>
    <el-form-item label="排词成句分隔" :error="errors.pxtAnswers">
      <el-input v-model="pxtAnswers" @blur="handleFormatMultiLines('pxtAnswers')" type="textarea"
                :autosize="{minRows:1}"
                resize="none"
                placeholder="留空则不出这道题"></el-input>
    </el-form-item>
    <el-form-item v-if="pxtAnswers.length" label="排词成句音频">
      <div v-for="item in formData.pxt_audios" :key="item.text">
        <FileInput v-model="item.audio" accept="audio/*" :label="item.text" :title="item.text"></FileInput>
      </div>
    </el-form-item>
    <el-form-item label="启用的题型">
      <el-checkbox-group v-model="enabledTypes" style="line-height: 2;">
        <el-checkbox v-for="(item, key) in allowSelectTypes" :key="key" :label="item.id">
          {{ item.label }}
        </el-checkbox>
      </el-checkbox-group>
      <div class="text-info" style="line-height: 2;">
        设置句子生成题目时可用的题型，未选中不生成，选中的请检查数据是否正确
      </div>
    </el-form-item>
  </div>
</template>

<script>
import _ from 'lodash';
import {exrTypeList, handleFormat, validateWords} from "./util.js";

const rules = {
  xktc: [
    validateWords,
    function (words, value, opts) {
      if (!value) {
        return;
      }
      if (!/__/.test(value)) {
        return '缺少挖空数据';
      }
      const parts = value.match(/\[.*?]/g);
      if (parts && parts.length !== 1) {
        return '必须要有1个正确答案挖空';
      }
    }
  ],
  xctk_4x1: [
    validateWords,
    function (words, value, opts) {
      if (!value) {
        return;
      }
      const parts = value.match(/\[.*?]/g);
      if (parts && parts.length !== 1) {
        return '必须要有1个挖空';
      }
    }
  ],
  xctk_4x2: [
    validateWords,
    function (words, value, opts) {
      if (!value) {
        return;
      }
      const parts = value.match(/\[.*?]/g);
      if (parts && parts.length !== 2) {
        return '必须要有2个挖空';
      }
    }
  ],
  pxtAnswers: [
    validateWords
  ]
}

export default {
  name: "BuildExerciseConfig",
  components: {
    FileInput: require('@/components/FileInput').default
  },
  props: {
    value: Object,
    words: String,
  },
  data() {
    return {
      old_pxt_audios: {},
      formData: {
        xktc: '',
        xctk_4x1: '',
        xctk_4x1_items: '',
        // xctk_4x1_types: '',
        xctk_4x2: '',
        xctk_4x2_items: '',
        // xctk_4x2_types: '',
        pxt: [],
        // pxt_types: '',
        pxt_audios: [],
        enabled_types: '',
      },
      isChangedTypes: false,
      errors: {
        xktc: '',
        xctk_4x1: '',
        xctk_4x2: '',
        pxtAnswers: '',
      }
    }
  },
  computed: {
    enabledTypes: {
      get() {
        if (this.isChangedTypes) {
          return (this.formData.enabled_types || '').split(',').filter(s => /^\d+$/.test(s)).map(n => Number.parseInt(n));
        }
        return this.allowSelectTypes.map(n => n.id);
      },
      set(val) {
        this.formData.enabled_types = val.join(',');
        this.isChangedTypes = true;
      },
    },
    allowSelectTypes() {
      return exrTypeList.filter(n => !this.disableType(n));
    },
    pxtAnswers: {
      get() {
        return this.formData.pxt.join("\n");
      },
      set(val) {
        this.formData.pxt = val ? val.split(/\r\n|\n/) : [];
      },
    },
  },
  watch: {
    value: {
      handler(val) {
        val = val || {};
        const newVal = Object.assign({
          xktc: '',
          xctk_4x1: '',
          xctk_4x1_items: '',
          // xctk_4x1_types: '',
          xctk_4x2: '',
          xctk_4x2_items: '',
          // xctk_4x2_types: '',
          pxt: [],
          pxt_audios: [],
          // pxt_types: '',
          enabled_types: '',
        }, val);
        //pxt 这个字段必须是数组，这个值曾经在其他地方被修改过，特此加入这个判断
        if (!_.isArray(newVal.pxt)) {
          newVal.pxt = [];
        }
        if (!_.isEqual(newVal, this.formData)) {
          this.formData = newVal;
          this.isChangedTypes = val.enabled_types !== undefined && val.enabled_types !== null;
          this.old_pxt_audios = _.keyBy(newVal.pxt_audios, 'text');
        }
      },
      immediate: true,
    },
    formData: {
      deep: true,
      handler(val) {
        if (Object.keys(val).every(k => _.isEmpty(val[k]))) {
          val = null;
        }
        _.isEqual(val, this.value) || this.$emit('input', val);
      }
    },
    allowSelectTypes(val, oldVal) {
      const types = this.enabledTypes;
      let newTypes = _.intersection(types, val.map(n => n.id));
      if (newTypes.length !== types.length) {
        this.enabledTypes = newTypes;
      }
    },
    pxtAnswers(val) {
      const parts = (this.formData.pxt || []).map(n => n.split('|')).flat(1).map(s => s.replace(/^\s+|\s+$/g, '')).filter(s => /[\d\u4e00-\u9fa5]/.test(s));
      const oldAudios = this.old_pxt_audios;
      const audios = [...new Set(parts)].map(s => ({
        text: s,
        audio: oldAudios[s] ? oldAudios[s].audio : ''
      }));
      this.formData.pxt_audios = audios;
    }
  },
  methods: {
    handleFormat(path, format = 'text', opts) {
      handleFormat(this, format, path, opts || {});
      const key = path.replace('formData.', '');
      if (rules[key]) {
        const errorKey = 'errors.' + key;
        _.set(this, errorKey, rules[key].map(fn => fn(this.words, _.get(this, path), opts || {})).filter(err => err).join(', 且'));
      }
    },
    handleFormatMultiLines(path, format = 'text') {
      this.handleFormat(path, format, {multiLine: true});
    },
    disableType(item) {
      return item.require && item.require.some(key => _.isEmpty(this.formData[key]));
    }
  }
}
</script>

<style scoped>
.el-form-item {
  margin-bottom: 20px;
}
</style>